<template>
    <BasicTabs :tabs="tabs" :tab-key="tabKey">
        <slot />
    </BasicTabs>
</template>

<script lang="ts" setup>
import { withDefaults } from "vue";
import { CreditCardIcon, ReceiptRefundIcon } from "@heroicons/vue/24/solid";
import route from "ziggy-js";
import type TabItem from "@/types/Settings/TabItem";
import { useTranslations } from "@/composables/useTranslations";

interface BillingTabProps {
    tabKey: string;
}

withDefaults(defineProps<BillingTabProps>(), {
    tabKey: "billing",
});

const { t } = useTranslations();

const tabs: TabItem[] = [
    {
        title: t("vue.subscriptions"),
        key: "subscriptions",
        icon: CreditCardIcon,
        url: route("billing.subscriptions.index"),
    },
];
</script>
